import { IAccessPayload } from "@/@types/auth/token-servises";
import { ServersCode } from "@/config/servers-code.config";
import { AuthAPI } from "./authorization/user-authorized-module";
import { nextTick } from "vue";
import { useRoute } from "vue-router";
import router from "@/router";

export const AccessToken = {
  get access(): string {
    return localStorage.getItem("access") || "";
  },

  get refreshToken(): string {
    return localStorage.getItem("refreshToken") || "";
  },

  get payload(): IAccessPayload | null {
    const token = AccessToken.access;
    if (!token) return null;

    try {
      const payload = token.split(".")[1];
      if (!payload) return null;
      const decoded = atob(payload);

      return JSON.parse(decoded) as IAccessPayload;
    } catch (error) {
      console.error("Invalid token format:", error);
      return null;
    }
  },

  get id(): string {
    return AccessToken.payload?.id || "";
  },

  get permissions(): string[] {
    const payload = AccessToken.payload;
    if (!payload) return [];
    return payload.permissions || [];
  },

  get userRole(): string | null {
    const payload = AccessToken.payload;
    if (!payload) return null;
    return payload.rules;
  },

  get isAuthorized(): boolean {
    return !!AccessToken.refreshToken;
  },

  get isExpired(): boolean {
    const payload = AccessToken.payload;
    if (!payload || !payload.exp) return true;

    return Date.now() >= payload.exp * 1000;
  },

  get isValid(): boolean {
    return !!AccessToken.payload && !AccessToken.isExpired;
  },

  hasPermission(server: string): boolean {
    const payload = AccessToken.payload;
    if (!payload) return false;
    return payload.permissions.includes(server);
  },

  checkAccess(requestCode: ServersCode): boolean {
    if (isRoot()) return true;
    return AccessToken.permissions.includes(requestCode);
  },

  set setAccessToken(token: string) {
    localStorage.setItem("access", token);
  },

  set setRefreshToken(token: string) {
    localStorage.setItem("refreshToken", token);
  },

  deleteAccessToken() {
    localStorage.removeItem("access");
  },

  deleteRefreshToken() {
    localStorage.removeItem("refreshToken");
  },

  logout() {
    const route = useRoute();
    if (route?.name === "login") return;
    if (AccessToken.access) AuthAPI.logout();
    nextTick(() => {
      AccessToken.deleteAccessToken();
      AccessToken.deleteRefreshToken();
      router.replace({ name: "login" });
    });
  },
};

export function isRoot(): boolean {
  return AccessToken.userRole === "root";
}

export function isAdmin(): boolean {
  return AccessToken.userRole === "admin";
}
